import styled from 'styled-components'
import { ICardConvidadoHistoryStyleProps } from './types'

export const Container = styled.div<ICardConvidadoHistoryStyleProps>`
    display: flex;
    gap:20px;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.tertiary};
    border-left: 10px solid ${props => props.$tagColor};
    border-radius: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const GroupContainer =styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const GroupLabels = styled.div`
    display: flex;
    flex: 1;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const LabelCard = styled.span`
    display: flex;
    flex-wrap: wrap;
    word-break: break-all;
    font-size: 16px;
`